export default "__VITE_ASSET__DRDjTOpV__"